import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { getRecognizeAudienceInsights } from "./get-recognize-audience-insights";
import { getRecognizeVips } from "./get-recognize-vips";
import { getRecognizeActions, saveRecognizeActions } from "./recognize-actions";
import {
  getRecognizeRunFilters,
  saveRecognizeRunFilters,
} from "./recognize-run-filters";

export const recognizeRpcDefinition = {
  getRecognizeRunFilters,
  saveRecognizeRunFilters,
  getRecognizeActions,
  saveRecognizeActions,
  getRecognizeAudienceInsights,
  getRecognizeVips,
};

export type RecognizeRpcDefinition = InferRpcDefinition<
  typeof recognizeRpcDefinition
>;
